import type { Market } from 'src/interfaces/market'
import type { State } from '../reducers/types'

/**
 * Returns the stored array by reference. Never build a new array or object literal in a
 * selector — every consuming `useSelector` would re-render on each dispatch. Filtering and
 * sorting belong in the component under `useMemo`.
 */
export const getMarkets = (state: State): Market[] => {
  return state.market.markets
}

export const getMarketsLoading = (state: State): boolean => {
  return state.market.marketsLoading
}

export const getMarketsError = (state: State): string | null => {
  return state.market.marketsError
}

export const getMarketSaving = (state: State): boolean => {
  return state.market.saving
}
